import { BASE_PATH, Pages } from 'components/config/pages';

export const findPathPages = (id) => Pages[id]?.path ?? BASE_PATH;
